import lozad from 'lozad';
import bus from '../util/eventBus';

const lazy = () => {
  const lazyEl = document.querySelector('.u-lazy');

  if (lazyEl) {
    const observer = lozad('.u-lazy', {
      rootMargin: '10px 0px',
      threshold: 0.1,
    });
    const observe = () => observer.observe();
    observe();

    bus.on('arca-slide-change', () => observe());

    bus.on('arca-modal-loaded', () => observe());

    document.addEventListener('facetwp-loaded', () => observe());
    document.addEventListener('facetwp-refresh', () => observe());

    const liveSearchWrapper = document.querySelectorAll('.c-searchwrapper');
    if (liveSearchWrapper.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < liveSearchWrapper.length; i++) {
        // create an observer instance
        // eslint-disable-next-line no-unused-vars
        const searchObserver = new MutationObserver(mutations => {
          observe();
        });
        // configuration of the observer:
        const searchConfig = {
          childList: true,
          subtree: true,
        };
        // pass in the target node, as well as the observer options
        searchObserver.observe(liveSearchWrapper[i], searchConfig);
      }
    }
    document.addEventListener('searchwp_live_search_shutdown', () => observe());

    document.addEventListener('DOMContentLoaded', () => observe, {
      once: true,
    });
  }
};

lazy();
